import React from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import BaseModal from '../../common/BaseModal/BaseModal';
import { getModalData } from '#/redux/modules/modal/selectors';
import { actions, updateProfileId } from '#/redux/modules/onboarding/actions';
import { getDraftProfile } from '#/redux/modules/onboarding/selectors';
import { Avatar } from '#/widgets/ui';
import { getAvatars } from '#/redux/modules/firestore/selectors';
import { isUserLogged } from '#/redux/modules/user/selectors';
import styles from './ProfileToWatchNoneModal.scss';
import { addUnsavedProfiles } from '#/redux/modules/identity/actions';
import { actions as modalActions } from '#/redux/modules/modal/actions';
import routes from '#/utils/routes';
import { isWorkstation } from '#/utils/componentStyleConfig';
import { InfoInput } from '#/widgets/forms';
import { PROFILECREATION } from '#/utils/navigationHelper';
import {
  getEditAvatar,
  getEditAvatarFocused,
} from '#/redux/modules/accedoOne/selectors';

const ProfileToWatchNoneModal = ({ history }) => {
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector(isUserLogged);
  const profile = useSelector(getDraftProfile);
  const avatarOptions = useSelector(getAvatars);
  const { addProfile, age, name } = useSelector(state => getModalData(state));
  const defaultAvatar =
    avatarOptions[Math.floor(Math.random() * avatarOptions.length)];
  const EditAvatar = useSelector(getEditAvatar);
  const EditAvatarFocused = useSelector(getEditAvatarFocused);

  const avatarDisplay = (
    <Avatar
      profile={{
        ...profile,
        avatar: EditAvatar,
        avatarFocused: EditAvatarFocused,
      }}
      className={styles.profileImage}
      focusEnabled
    />
  );

  const avatarDisplaySelected = (
    <Avatar
      profile={{
        ...profile,
        avatar: profile?.avatar,
      }}
      className={styles.profileImage}
    />
  );

  const cancelAction = async () => {
    const cloneProfile = {
      ...profile,
      avatar: defaultAvatar,
      age: `${age}`,
      birthdayMonth: '1',
      name,
    };
    dispatch({
      type: String(actions.setProfileAvatar),
      payload: defaultAvatar,
    });
    await dispatch(actions.setProfileFields(cloneProfile));
    await dispatch(actions.setProfileSkip(name));
    await dispatch(actions.saveProfile());
    if (isUserLoggedIn) {
      await dispatch(addUnsavedProfiles(updateProfileId));
    }

    history.push(routes.HOME);
    dispatch(modalActions.closeModal());
  };

  const avatarAction = () => {
    dispatch(
      modalActions.openModal({
        modalId: isWorkstation() ? 'AvatarModal' : 'AvatarModalTV',
        successAction: {
          type: String(actions.setProfileAvatar),
        },
      }),
    );
  };

  const saveAction = () => {
    dispatch(modalActions.closeModal());
    addProfile(profile.name, profile.avatar);
  };

  return (
    <BaseModal
      saveButtonText="Create Profile"
      showCancelButton
      cancelButtonText="Skip"
      saveAction={() => () => saveAction()}
      cancelAction={cancelAction}
      className={styles.modalContainer}
      buttonContainerClassName={styles.buttonContainer}
      saveButtonClassName={styles.createProfileButton}
      cancelButtonClassName={styles.skipButton}
      saveButtonDisabled={!(profile?.name && profile?.avatar)}
      nav={{
        id: PROFILECREATION.CONTAINER,
      }}
    >
      <div>
        <h2>Create Profile</h2>
        <p>Set up a profile to explore favorites and continue watching.</p>
        <div
          role="button"
          tabIndex={0}
          onClick={avatarAction}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              avatarAction();
            }
          }}
          className={styles.profileHolder}
        >
          {profile?.avatar ? avatarDisplaySelected : avatarDisplay}
        </div>
        <InfoInput
          fieldNameChange={event => {
            const cloneProfile = {
              ...profile,
              age: `${age}`,
              birthdayMonth: '1',
              name: event.target.value,
            };
            dispatch(actions.setProfileFields(cloneProfile));
          }}
          fieldValue={profile?.name}
          fieldName="name"
          placeHolder="Add Name"
          inputAttributes={{
            type: 'text',
            pattern: '[a-zA-Z]+',
            required: 'required',
            maxLength: '16',
          }}
          nav={{}}
          className={styles.infoInput}
        />
        {!(profile?.name && profile?.avatar) && (
          <p className={styles.formHint}>
            Please enter a name and choose an avatar
          </p>
        )}
      </div>
    </BaseModal>
  );
};

ProfileToWatchNoneModal.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ProfileToWatchNoneModal);
